import React from 'react';

import PropTypes from 'prop-types';
import { injectIntl } from 'react-intl';

const MicrosoftLogo = ({ title = '', ...props }) => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" {...props}>
      <title>{title || 'Microsoft'}</title>

      <svg
        width="17"
        height="17"
        viewBox="0 0 17 17"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        <path d="M0 0H17V17H0V0Z" fill="#F3F3F3" />
        <path d="M0.739258 0.739258H8.13056V8.13056H0.739258V0.739258Z" fill="#F35325" />
        <path d="M8.86963 0.739258H16.2609V8.13056H8.86963V0.739258Z" fill="#81BC06" />
        <path d="M0.739258 8.86914H8.13056V16.2604H0.739258V8.86914Z" fill="#05A6F0" />
        <path d="M8.86963 8.86914H16.2609V16.2604H8.86963V8.86914Z" fill="#FFBA08" />
      </svg>
    </svg>
  );
};

MicrosoftLogo.propTypes = {
  title: PropTypes.string,
  intl: PropTypes.object.isRequired,
};

export default injectIntl(MicrosoftLogo);
